// 检查是否已经定义了 product-form 自定义元素
if (!customElements.get('product-form')) {
  customElements.define(
    'product-form',
    class ProductForm extends HTMLElement {
      constructor() {
        super();
        
        // 初始化表单相关元素
        this.form = this.querySelector('form');
        this.variantIdInput.disabled = false;  // 启用商品变体ID输入
        this.form.addEventListener('submit', this.onSubmitHandler.bind(this));  // 添加表单提交事件监听
        // 获取购物车通知或抽屉组件
        this.cart = document.querySelector('cart-notification') || document.querySelector('cart-drawer');
        this.submitButton = this.querySelector('[type="submit"]');  // 获取提交按钮
        this.submitButtonText = this.submitButton.querySelector('span');  // 获取按钮文本元素

        // 如果存在购物车抽屉，设置按钮的 aria-haspopup 属性
        if (document.querySelector('cart-drawer')) this.submitButton.setAttribute('aria-haspopup', 'dialog');

        // 是否隐藏错误信息
        this.hideErrors = this.dataset.hideErrors === 'true';
      }

      // 处理表单提交的方法
      onSubmitHandler(evt) {
        evt.preventDefault();  // 阻止表单默认提交行为
        // 如果按钮被禁用，直接返回
        if (this.submitButton.getAttribute('aria-disabled') === 'true') return;

        this.handleErrorMessage();  // 处理错误信息

        // 设置按钮状态为加载中
        this.submitButton.setAttribute('aria-disabled', true);
        this.submitButton.classList.add('loading');
        this.querySelector('.loading__spinner').classList.remove('hidden');

        // 配置fetch请求
        const config = fetchConfig('javascript');
        config.headers['X-Requested-With'] = 'XMLHttpRequest';
        delete config.headers['Content-Type'];

        // 准备表单数据
        const formData = new FormData(this.form);
        if (this.cart) {
          // 添加购物车相关的部分数据
          formData.append(
            'sections',
            this.cart.getSectionsToRender().map((section) => section.id)
          );
          formData.append('sections_url', window.location.pathname);
          this.cart.setActiveElement(document.activeElement);
        }
        config.body = formData;

        // 发送添加到购物车的请求
        fetch(`${routes.cart_add_url}`, config) 
          .then((response) => response.json())
          .then((response) => {
            // 处理错误状态
            if (response.status) {
              // 发布购物车错误事件
              publish(PUB_SUB_EVENTS.cartError, {
                source: 'product-form',
                productVariantId: formData.get('id'),
                errors: response.errors || response.description,
                message: response.message,
              });
              this.handleErrorMessage(response.description);

              // 处理商品售罄情况
              const soldOutMessage = this.submitButton.querySelector('.sold-out-message');
              if (!soldOutMessage) return;
              this.submitButton.setAttribute('aria-disabled', true);
              this.submitButtonText.classList.add('hidden');
              soldOutMessage.classList.remove('hidden');
              this.error = true;
              return;
            } 
            // 如果没有购物车组件，直接跳转到购物车页面
            else if (!this.cart) {
              window.location = window.routes.cart_url;
              return;
            }

            // 发布购物车更新事件
            if (!this.error)
              publish(PUB_SUB_EVENTS.cartUpdate, {
                source: 'product-form',
                productVariantId: formData.get('id'),
                cartData: response,
              });
            this.error = false;

            // 处理快速添加模态框的情况
            const quickAddModal = this.closest('quick-add-modal');
            if (quickAddModal) {
              document.body.addEventListener(
                'modalClosed',
                () => {
                  setTimeout(() => {
                    this.cart.renderContents(response);
                  });
                },
                { once: true }
              );
              quickAddModal.hide(true);
            } else {
              this.cart.renderContents(response);
            }
          })
          .catch((e) => {
            console.error(e);
          })
          .finally(() => {
            // 完成后重置按钮状态
            this.submitButton.classList.remove('loading');
            if (this.cart && this.cart.classList.contains('is-empty')) this.cart.classList.remove('is-empty');
            if (!this.error) this.submitButton.removeAttribute('aria-disabled');
            this.querySelector('.loading__spinner').classList.add('hidden');
          });
      }

      // 处理错误信息显示的方法
      handleErrorMessage(errorMessage = false) {
        if (this.hideErrors) return;

        this.errorMessageWrapper =
          this.errorMessageWrapper || this.querySelector('.product-form__error-message-wrapper');
        if (!this.errorMessageWrapper) return;
        this.errorMessage = this.errorMessage || this.errorMessageWrapper.querySelector('.product-form__error-message');

        this.errorMessageWrapper.toggleAttribute('hidden', !errorMessage);

        if (errorMessage) {
          this.errorMessage.textContent = errorMessage;
        }
      }

      // 切换提交按钮状态的方法
      toggleSubmitButton(disable = true, text) {
        if (disable) {
          this.submitButton.setAttribute('disabled', 'disabled');
          if (text) this.submitButtonText.textContent = text;
        } else {
          this.submitButton.removeAttribute('disabled');
          this.submitButtonText.textContent = window.variantStrings.addToCart;
        }
      }

      // 获取商品变体ID输入框的getter方法
      get variantIdInput() {
        return this.form.querySelector('[name=id]');
      }
    }
  );
}
